module.exports = __webpack_public_path__ + "img/1573464424.9c6548d8.jpg";